export const GET_CV_PDF = "GET_CV_PDF";
